// Only a real difference between the raw table and net price is a discount.
export function precoComDescontoConfirmado(resposta, doacao = false) {
  if (doacao || !resposta || resposta._pedidoDoacao === true || resposta._tipoPedido === 'WC' || resposta.assessmentFlag === true || resposta.fonte === 'db' || resposta.calculoFiscal === false) return false;
  const raw = resposta.raw;
  if (!raw || raw.PrecoLiquido == null || raw.PrecoTabela == null) return false;
  return Number.isFinite(Number(raw.PrecoLiquido)) && Number.isFinite(Number(raw.PrecoTabela))
    && Number(raw.PrecoLiquido) > 0 && Number(raw.PrecoTabela) > Number(raw.PrecoLiquido);
}

// Select by order type, never by truthiness. Explicit zero cannot fall back.
export function precoFinalSimulado(resposta) {
  if (!resposta) return null;
  const raw = resposta.raw;
  const doacao = resposta._pedidoDoacao === true;
  const keys = doacao
    ? [['PrecoDoacao', 'precoDoacao']]
    : (resposta._tipoPedido === 'WC' || resposta.assessmentFlag === true)
      ? [['PrecoTabela', 'precoComImposto']]
      : [['PrecoLiquido', 'valorComDesconto']];
  for (const [key, alias] of keys) {
    const value = raw?.[key] ?? resposta[alias];
    if (value !== null && value !== undefined && value !== '') {
      const preco = Number(value);
      return Number.isFinite(preco) ? preco : null;
    }
  }
  return null;
}

// Snapshot from the current fiscal simulation, never reconstructed from a
// discount or from the commercial (net) price.
export function precoTabelaSimulado(resposta) {
  if (!resposta || resposta._erro) return null;
  const value = resposta.raw?.PrecoTabela ?? resposta.precoComImposto;
  if (value === null || value === undefined || value === '') return null;
  const preco = Number(value);
  return Number.isFinite(preco) ? preco : null;
}
